export default __webpack_public_path__ + "static/combineSectionBg-3dc3e91c2db8b85183ef0f1ba7f40f08.png";